(() => {
  'use strict';
  const mount = root => {
    if (root.dataset.depthMounted) return;
    root.dataset.depthMounted = 'true';
    const scene = root.querySelector('[data-depth-scene]');
    const toggle = root.querySelector('[data-depth-pause]');
    const media = matchMedia('(prefers-reduced-motion:no-preference)');
    const desktop = matchMedia('(min-width:900px) and (min-height:700px) and (hover:hover) and (pointer:fine)');
    const abort = new AbortController(), signal = abort.signal;
    let inView = false, paused = false, frame = 0, x = 0, y = 0, active = false;
    const clamp = (n, a, b) => Math.min(b, Math.max(a, n));
    const eligible = () => media.matches && !paused && !document.hidden;
    const reset = () => {
      cancelAnimationFrame(frame); frame = 0; x = y = 0;
      root.removeAttribute('data-depth-active');
      ['rx','ry','rz','y','x','progress','orbit','light'].forEach(k => root.style.removeProperty('--depth-' + k));
    };
    const update = () => {
      frame = 0;
      if (!eligible() || !inView) return;
      const rect = root.getBoundingClientRect();
      const plate = root.querySelector('.re-depth__plate');
      const distance = Math.max(1, rect.height - plate.offsetHeight);
      const top = parseFloat(getComputedStyle(root).getPropertyValue("--depth-top")) || 162;
      const sceneRect = scene.getBoundingClientRect();
      const progress = desktop.matches
        ? clamp((top - rect.top) / distance, 0, 1)
        : clamp((window.innerHeight * .85 - sceneRect.top) / (window.innerHeight * .7 + sceneRect.height * .35), 0, 1);
      // A complete opening, a reversible change, then a readable final hold.
      const t = clamp((progress - .1) / .7, 0, 1);
      const p = t * t * (3 - 2 * t);
      const values = desktop.matches ? {
        rx: (7 - p * 10 - y * 5).toFixed(2) + 'deg',
        ry: (-17 + p * 28 + x * 9).toFixed(2) + 'deg',
        rz: (-12 + p * 15 + x * 2).toFixed(2) + 'deg',
        x: (-10 + p * 22 + x * 12).toFixed(2) + 'px',
        y: (13 - p * 24 + y * 7).toFixed(2) + 'px',
        orbit: (-29 + p * 55 - x * 6).toFixed(2) + 'deg',
        progress: progress.toFixed(4)
      } : {
        rx: (4 - p * 8).toFixed(2) + 'deg',
        ry: (-10 + p * 20).toFixed(2) + 'deg',
        rz: (-6 + p * 11).toFixed(2) + 'deg',
        x: (-3 + p * 6).toFixed(2) + 'px',
        y: (8 - p * 14).toFixed(2) + 'px',
        orbit: (-22 + p * 38).toFixed(2) + 'deg',
        progress: progress.toFixed(4)
      };
      Object.entries(values).forEach(([k,v]) => root.style.setProperty('--depth-' + k,v));
    };
    const schedule = () => {if (inView && eligible() && !frame) frame = requestAnimationFrame(update);};
    const sync = () => {
      const next = media.matches && !document.hidden;
      root.dataset.depthReady = String(media.matches);
      toggle.hidden = !media.matches;
      if (next && !active) {window.addEventListener('scroll',schedule,{passive:true,signal}); active = true;}
      if (!next && active) {window.removeEventListener('scroll',schedule); active = false;}
      if (!eligible()) reset();
      else {root.dataset.depthActive = String(inView);schedule();}
    };
    const observer = new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      if (inView) {root.dataset.depthActive = String(eligible()); schedule();}
      else {cancelAnimationFrame(frame);frame = 0;root.removeAttribute('data-depth-active');x = y = 0;}
    },{threshold:0});
    observer.observe(root);
    scene.addEventListener('pointermove',event => {
      if (!eligible() || !desktop.matches || event.pointerType !== 'mouse') return;
      const rect = scene.getBoundingClientRect();
      x = clamp((event.clientX - rect.left) / rect.width * 2 - 1,-1,1);
      y = clamp((event.clientY - rect.top) / rect.height * 2 - 1,-1,1);
      schedule();
    },{passive:true,signal});
    const neutral = () => {x = y = 0;schedule();};
    scene.addEventListener('pointerleave',neutral,{passive:true,signal});
    scene.addEventListener('pointercancel',neutral,{passive:true,signal});
    root.addEventListener('focusin',neutral,{signal});
    toggle.addEventListener('click',() => {
      paused = !paused;
      toggle.setAttribute('aria-pressed',String(paused));
      toggle.setAttribute('aria-label',paused ? '3D-Bewegung fortsetzen' : '3D-Bewegung anhalten');
      toggle.innerHTML = paused ? '<span aria-hidden="true">▷</span> Bewegung fortsetzen' : '<span aria-hidden="true">Ⅱ</span> Bewegung anhalten';
      sync();
    },{signal});
    window.addEventListener('resize',sync,{passive:true,signal});
    document.addEventListener('visibilitychange',sync,{signal});
    media.addEventListener('change',sync,{signal});
    desktop.addEventListener('change',sync,{signal});
    window.addEventListener('pageshow',sync,{signal});
    window.addEventListener('pagehide',() => {cancelAnimationFrame(frame);frame = 0;},{signal});
    document.addEventListener('shopify:section:unload',event => {
      if (!event.target.contains(root)) return;
      observer.disconnect();abort.abort();cancelAnimationFrame(frame);
    },{signal});
    sync();
  };
  document.querySelectorAll('[data-console-depth]').forEach(mount);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-console-depth]').forEach(mount));
})();
